<template>
  <div>
    <v-dialog
      :value="true"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      transition="slide-y-reverse-transition"
      max-width="800"
      scrollable
      persistent
    >
      <AwardForm
        :award="editedAward"
        :errors="awardsValidationErrors"
        :disabled="savingAward"
        @clear:errors="clearAwardsValidationErrors"
        @cancel="$router.push({ name: 'awards' })"
        @save="onSave"
        @preview="onPreview"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AwardForm from '../../components/AwardForm';
import store from '../../store';

export default {
  name: 'editAward',

  components: { AwardForm },

  computed: mapState('awards', ['editedAward', 'awardsValidationErrors', 'savingAward']),

  beforeRouteEnter(to, from, next) {
    store
      .dispatch('awards/editAward', to.params.id)
      .then(() => {
        next();
      })
      .catch(() => {
        next({ name: 'awards' });
      });
  },

  methods: {
    ...mapActions('awards', ['updateAward', 'clearAwardsValidationErrors']),

    onSave(award) {
      this.updateAward(award).then(() => {
        this.$router.push({ name: 'awards' });
      });
    },

    onPreview(award) {
      this.updateAward(award).then(() => {
        window.open(this.$previewBackendUrl('apie?'));
      });
    },
  },
};
</script>

<style scoped></style>
